import chroma from 'chroma-js';
import * as styleOps from '../../api/Styles/style-operations';

// eslint-disable-next-line no-useless-escape
const COLOR_EXPRESION = /(?:#|0x)(?:[a-f0-9]{3}|[a-f0-9]{6})\b|(?:rgb|hsl)a?\([^\)]*\)/gi;
const COLOR_REGEX = new RegExp(COLOR_EXPRESION);

const leafletLegendGenerator = style => {
  let legendContent = '';
  let legend;
  let background;
  switch (true) {
    case styleOps.isSingleSimbology(style):
      if (styleOps.getColor(style).match(COLOR_REGEX)) {
        background = chroma(styleOps.getColor(style)).css();
        legendContent += `
        <div style="
        width: 36px;
        height: 14px;
        border-radius: 2px;
        background: ${background};
        opacity: ${styleOps.getAlpha(style)};
        margin: auto;
        ">
        </div>
        `;
      } else {
        legendContent += `
        <div style="
        width: 36px;
        height: 14px;
        border-radius: 2px;
        margin: auto;
        ">
        Default
        </div>
        `;
      }
      break;
    default:
      legend = styleOps.getLegend(style);
      legend.forEach(element => {
        legendContent += `
          <div style="text-align: left; width: calc(100% + 50px)">
            <p style="display:inline-block; white-space: nowrap" className="text-left">
              ${element.value}
            </p>
            <div style="
              width: 36px;
              height: 14px;
              border-radius: 2px;
              background: ${element.color};
              opacity: ${styleOps.getAlpha(style)};
              display: inline-block;
              float: right;
              ">
            </div>
          </div>
        `;
      });
      break;
  }
  return legendContent;
};

export default leafletLegendGenerator;
